// What to take from a page or screenshot they brought, from their answers to its question
// (backend core/source_questions): the places they ticked are theirs (they join the wishlist),
// the rest ride as ideas; a stay becomes the city's base; "add that city" goes back to the cities.
export function applySourceAnswers(reading, answers) {
  const names = (reading?.places || []).map(p => p.name);
  const out = { musts: [], ideas: [], base: null, addCity: "", note: "" };
  Object.entries(answers || {}).forEach(([key, value]) => {
    const values = (Array.isArray(value) ? value : [value]).filter(v => v && v !== "__skip__");
    if (key === "source:pick") out.musts = values.filter(v => names.includes(v));
    else if (key.startsWith("source:one:") && values[0] === "must") out.musts = names.slice(0, 1);
    else if (key === "source:stay" && values[0] === "yes") {
      const stay = (reading?.places || [])[0];
      if (stay?.city) out.base = { city: stay.city, name: stay.name };
    } else if (key === "source:away" && values[0] === "add_city") {
      out.addCity = (reading?.places || []).map(p => p.city).find(Boolean) || "";
    } else if (key === "source:nothing" && values[0] && values[0] !== "never_mind") out.note = String(values[0]).slice(0, 300);
  });
  out.ideas = names.filter(n => !out.musts.includes(n));
  return out;
}
